import {defaultStatuses} from "@/enums";

const namespaced = true;

const defaultState = () => {
  return {
    fleetCount: 0,
    loading: false,
    search: "",
    query: false,
    companyFilter: "",
    multiFilter: [],
    statusFilter: [],
    fleetComposition: [],
    fleetCompositionViaLocations: [],
    filterCount: 0,
    provider:""
  };
};

const state = defaultState();
const actions = {};
const mutations = {
  resetState(state){
    Object.assign(state,defaultState())
  },
  SET_PROVIDER(state, provider){
    state.provider = provider
  },
  RESET_FILTER(state, val) {
    state.search = "";
    state.multiFilter = [];
    state.statusFilter = defaultStatuses;
    state.companyFilter = "";
    state.provider = ""
  },
  SET_FILTER_COUNT(state, filterCount) {
    state.filterCount = filterCount;
  },
  SET_QUERY(state, query) {
    state.query = query;
  },
  SET_FLEET_COMPOSITION_VIA_LOCS(state, fleetCompositionViaLocations) {
    state.fleetCompositionViaLocations = fleetCompositionViaLocations;
  },
  SET_FLEET_COMPOSITION(state, fleetComposition) {
    state.fleetComposition = fleetComposition;
  },
  SET_COMPANY_FILTER(state, companyFilter) {
    state.companyFilter = companyFilter;
  },
  SET_SEARCH(state, search) {
    state.search = search;
  },
  SET_ANALYSIS(state, loading) {
    state.loading = loading;
  },
  SET_FLEET_COUNT(state, fleetCount) {
    state.fleetCount = fleetCount;
  },
  SET_MULTI_FILTER(state, multiFilter) {
    state.multiFilter = multiFilter;
  },
  REMOVE_MULTI_FILTER(state, index) {
    state.multiFilter.splice(index, 1);
  },
  SET_STATUS_FILTER(state, statusFilter) {
    state.statusFilter = statusFilter;
  },
  REMOVE_STATUS_FILTER(state, index) {
    state.statusFilter.splice(index, 1);
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
};
const getters = {};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};
